export default {
  title: 'Reference Models',
  createButton: 'Create Reference Model',
  searchLabel: 'Search',
  headers: {
    categoryName: 'Category Name',
    codename: 'Codename',
    pkl: 'PKL',
    pklSize: 'PKL Size',
    modified: 'Modified',
    actions: 'Actions',
    disabled: 'Disabled',
    status: 'Status'
  },
  tooltips: {
    edit: 'Edit Reference Model',
    delete: 'Delete Reference Model',
    updateCustomModels: 'Update existing Custom Models'
  },
  deleteDialog: {
    title: 'Warning',
    message: 'Deleting Reference Model:',
    confirmation: 'This action cannot be undone. Are you sure?',
    cancel: 'Cancel',
    delete: 'Delete'
  },
  updateDialog: {
    title: 'Warning',
    message: 'Updating existing Custom Models for Reference Model:',
    confirmation: 'This action cannot be undone. Are you sure?',
    cancel: 'Cancel',
    update: 'Update'
  }
}
